import React from 'react'
import Navbar from '../inc/Navbar'
import KidCCD3Forte from "../images/CC D3 NEW DESIGN.jpg";
import kidCCd3 from "../images/Kid CC-D3 Drops.jpg"
function Kidccd3() {
  return (
    <div>
      <Navbar />
      <br />
      <br />
      <br />
      <br />
      <img src={KidCCD3Forte} className="d-block w-100" alt="KidCCD3Forte" />
      <div className='LysorichSyrup'>
        <div className="album py-1">
          <div className="container">
            <center>
              <h2 className='mt-3'>Kid CC-D3 Drops</h2>
              <p>Impaired Growth In Vitamin D3 Deficiency Rickets</p>
            </center>
          </div>
        </div>
      </div>
      <b />

      <div className="album py-1">
        <div className="container">
          <center>
            <h1><b>Kid CC-D3 Drops</b> Uses </h1>
          </center>
        </div>
      </div>

      <div className="album py-1">
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <img src={kidCCd3} className="img-fluid " alt="kidCCd3" />

            </div>

            <div className="col-md-8">
              <br/>
              <br/>
              <h5 style={{color:"#0499a0"}} className='mb-2'><b>Regulates the immune system</b></h5>
               <h5 style={{color:"#0499a0"}}  className='mb-2'><b>Maintains healthy nerves and muscles</b></h5>
               <h5 style={{color:"#0499a0"}}  className='mb-2'><b>Promotes healthy growth & development in infancy & childhood</b></h5>

                      <h5 style={{color:"#0499a0"}}  className='mb-0'><b>Stimulates the body to absorb calcium for strong bones & teeth</b></h5>

            </div>
          </div>
          <br/>
          <br/>
          <br/>
          <div className='bg'>
            <br/>
          <center>
<p className='mb-1'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
  <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0"/>
  <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"/>
</svg> Vitamin B-Complex deficiency</p>
<p className='mb-1'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
  <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0"/>
  <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"/>
</svg> Low Appetite</p>

<p className='mb-1'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
  <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0"/>
  <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"/>
</svg> Oxidative Stress</p>
<p className='mb-1'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
  <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0"/>
  <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"/>
</svg> General Disability & Convalescence</p>
<p className='mb-1'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
  <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0"/>
  <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"/>
</svg> Low HB</p>
<p className='mb-1'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
  <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0"/>
  <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"/>
</svg> Growth Phase</p>
<p className='mb-1'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
  <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0"/>
  <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"/>
</svg> Along with Antibiotics</p>
</center>
<br/>
</div>
        </div>
        </div>
        <br />
      </div>
      )
}

      export default Kidccd3